export enum MatchMode {
  Equals = "Equals",
  EqualsIgnoreCase = "EqualsIgnoreCase",
  StartsWith = "StartsWith",
  StartsWithIgnoreCase = "StartsWithIgnoreCase",
  Between = "Between",
  AnyOf = "AnyOf",
}
